import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'

import LayoutWithoutSidenav from '@/layout/LayoutWithoutSidenav'
import LayoutWithoutSidenavPadding from '@/layout/LayoutWithoutSidenavPadding'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [{
    path: '',
    component: LayoutWithoutSidenav,
    children: [{
      path: '',
      component: () => import(/* webpackChunkName: "home" */ '@/pages/Home')
    }]
  }, {
    path: '/',
    component: LayoutWithoutSidenavPadding,
    children: [{
      path: '/portfolio',
      component: () => import(/* webpackChunkName: "portfolio" */ '@/pages/Portfolio')
    }, {
      path: '/quem-somos',
      component: () => import(/* webpackChunkName: "we" */ '@/pages/We')
    }, {
      path: '/servicos',
      component: () => import(/* webpackChunkName: "service" */ '@/pages/Service')
    }, {
      path: '/fale-conosco',
      component: () => import(/* webpackChunkName: "talkToWe" */ '@/pages/TalkToWe')
    }, {
      path: '/trabalhe-conosco',
      component: () => import(/* webpackChunkName: "workToWe" */ '@/pages/WorkToWe')
    }, {
      path: '/segmento-energia',
      component: () => import(/* webpackChunkName: "energy" */ '@/pages/Energy')
    }, {
      path: '/segmento-infraestrutura',
      component: () => import(/* webpackChunkName: "infra" */ '@/pages/Infra')
    }, {
      path: '/segmento-naval',
      component: () => import(/* webpackChunkName: "naval" */ '@/pages/Naval')
    }, {
      path: '/segmento-petroquimico',
      component: () => import(/* webpackChunkName: "petro" */ '@/pages/Petro')
    }]
  }, {
    path: '*',
    redirect: '/'
  }]
})

router.afterEach(() => {
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  document.body.classList.add('app-loading')
  setTimeout(() => next(), 10)
})

export default router
